export const CrawlStatusEnum = {
  Pending: 'pending',
  Processing: 'processing',
  Completed: 'completed',
  Failed: 'failed',
  Cancelled: 'cancelled',
};

export const CrawlStatusColorTag = {
  [CrawlStatusEnum.Pending]: 'blue',
  [CrawlStatusEnum.Processing]: 'orange',
  [CrawlStatusEnum.Completed]: 'green',
  [CrawlStatusEnum.Failed]: 'red',
  [CrawlStatusEnum.Cancelled]: 'grey',
};

export const DEPTH_MODE = {
  PATH: 'path',
  CLICK: 'click',
};

export const DEFAULT_DEPTH_MODE = DEPTH_MODE.PATH;

export const DepthModes = [
  { value: DEPTH_MODE.PATH, label: 'Path' },
  { value: DEPTH_MODE.CLICK, label: 'Click Distance' },
];

export function getDepthModeLabel(value) {
  const option = DepthModes.find((mode) => mode.value === value);
  return option ? option.label : '-';
}

export const URL_REPORT_MODE = {
  NEW: 'new',
  ALL: 'all',
};

export const DEFAULT_URL_REPORT_MODE = URL_REPORT_MODE.NEW;

export const UrlReportModes = [
  { value: URL_REPORT_MODE.NEW, label: 'New URLs only' },
  { value: URL_REPORT_MODE.ALL, label: 'All crawled URLs' },
];

export function getUrlReportModeLabel(value) {
  const option = UrlReportModes.find((mode) => mode.value === value);
  return option ? option.label : '-';
}

export const ScheduleFrequencies = [
  { value: 'once', label: 'Once' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
];

export const DaysOfWeek = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];
